{
  "profile": {
    "overline": "ВАШЕ ПРОСТРАНСТВО",
    "title": "Мой",
    "titleHighlight": "Профиль",
    "removePhoto": "Удалить фото",
    "displayName": "Отображаемое имя",
    "displayNamePlaceholder": "Как к вам обращаться?",
    "timezone": "Часовой пояс",
    "selectTimezone": "Выберите часовой пояс",
    "searchTimezone": "Поиск часового пояса...",
    "selectTimezoneTitle": "Выбор часового пояса",
    "profileUpdated": "Профиль обновлён",
    "saveChanges": "СОХРАНИТЬ",
    "masterConsole": "Консоль мастера",
    "masterConsoleHint": "Управляйте учениями и Live-сессиями"
  },
  "account": {
    "title": "АККАУНТ",
    "emailVerified": "Email подтверждён",
    "emailNotVerified": "Email не подтверждён",
    "memberSince": "Участник с"
  },
  "preferences": {
    "title": "ПРЕДПОЧТЕНИЯ ПРАКТИК",
    "notSet": "Предпочтения ещё не установлены",
    "setupHome": "Настроить на главной",
    "practices": "Практики",
    "preferredTime": "Предпочитаемое время",
    "goals": "Цели",
    "format": "Формат"
  },
  "quickLinks": {
    "favorites": "Избранное",
    "following": "Подписки",
    "schedule": "Календарь",
    "notifications": "Уведомления"
  },
  "master": {
    "overline": "КОНСОЛЬ МАСТЕРА",
    "title": "Архитектор",
    "titleHighlight": "Коллектива",
    "subtitle": "Управляйте профилем, практиками и Live-сессиями.",
    "identity": "ЛИЧНОСТЬ",
    "displayName": "Отображаемое имя",
    "displayNamePlaceholder": "Как вас видят ученики",
    "biography": "Биография",
    "biographyPlaceholder": "Ваш духовный путь и философия...",
    "saveUpdates": "СОХРАНИТЬ",
    "viewPublic": "ПУБЛИЧНЫЙ ПРОФИЛЬ",
    "loading": "Открываем портал мастера...",
    "libraryTab": "БИБЛИОТЕКА",
    "manifestoTab": "МАНИФЕСТ",
    "communityTab": "СООБЩЕСТВО",
    "knowledgeLibrary": "БИБЛИОТЕКА ЗНАНИЙ",
    "practicesTab": "ПРАКТИКИ",
    "livesTab": "LIVE-СЕССИИ",
    "recordingsTab": "ЗАПИСИ",
    "addPractice": "Добавить практику",
    "addLive": "Добавить Live-сессию",
    "emptyLibrary": "Ваша библиотека пуста.",
    "noUpcoming": "Нет запланированных Live-сессий.",
    "goLive": "НАЧАТЬ LIVE-СЕССИЮ",
    "noRecordings": "Записей пока нет.",
    "playRecording": "ВОСПРОИЗВЕСТИ",
    "manifestoVideo": "ВИДЕО-МАНИФЕСТ",
    "currentVideo": "Текущее видео",
    "addManifesto": "Добавить видео-манифест",
    "addManifestoHint": "Представьтесь потенциальным ученикам",
    "communityFeed": "ЛЕНТА СООБЩЕСТВА",
    "writePost": "Новая публикация",
    "noPosts": "Публикаций нет. Поделитесь первой мыслью!",
    "nameRequired": "Имя обязательно",
    "savedTitle": "Сохранено",
    "savedMessage": "Ваши обновления на рассмотрении.",
    "manifestoTitleRequired": "Пожалуйста, введите название видео.",
    "deletePost": "Удалить публикацию",
    "deletePostConfirm": "Вы уверены, что хотите удалить публикацию?",
    "deletePractice": "Удалить практику",
    "deletePracticeConfirm": "Вы уверены, что хотите удалить практику?",
    "cancelLive": "Отменить Live-сессию",
    "deleteLive": "Удалить Live-сессию",
    "cancelLiveConfirm": "Это отменит сессию и уведомит подписчиков. Отменить нельзя.",
    "deleteLiveConfirm": "Вы уверены, что хотите удалить Live-сессию?",
    "failedLoadProfile": "Не удалось загрузить профиль",
    "failedLoadContent": "Не удалось загрузить контент",
    "yourProfile": "Ваш профиль",
    "coverImage": "Обложка",
    "quickAddPractice": "Практика",
    "quickLiveStream": "Live-сессия",
    "quickNewCircle": "Новый круг",
    "quickHostEvent": "Событие",
    "quickAddPost": "Публикация",
    "createNewCircle": "Создать новый круг",
    "noEventsThisDay": "Нет событий в этот день.",
    "addToSchedule": "Добавить в расписание",
    "addToSchedulePrompt": "Что вы хотите создать?",
    "event": "Событие",
    "deleteEvent": "Удалить событие",
    "deleteEventConfirm": "Вы уверены, что хотите удалить событие?",
    "archiveUrl": "Ссылка на архив или Live-сессию (необязательно)",
    "rejoin": "ВЕРНУТЬСЯ",
    "liveNow": "LIVE",
    "manifestoUpdated": "Видео-манифест успешно обновлён."
  },
  "masterModals": {
    "updatePractice": "Редактировать практику",
    "newPractice": "Новая практика",
    "practiceTitle": "Название практики",
    "practiceTitlePlaceholder": "напр. Глубокая утренняя тишина",
    "videoFile": "Видеофайл",
    "chooseVideo": "Выберите видео...",
    "durationMin": "Длительность (мин)",
    "durationPlaceholder": "20",
    "uploading": "ЗАГРУЗКА...",
    "saveToLibrary": "СОХРАНИТЬ",
    "updateLive": "Редактировать событие",
    "scheduleLive": "Запланировать событие",
    "sessionTitle": "Название события",
    "sessionTitlePlaceholder": "напр. Коллективное пробуждение",
    "sessionDescription": "Описание события",
    "sessionDescriptionPlaceholder": "О чем будет событие?",
    "date": "Дата",
    "time": "Время",
    "timezoneLabel": "Часовой пояс: {{tz}}",
    "datePlaceholder": "ГГГГ-ММ-ДД",
    "timePlaceholder": "ЧЧ:ММ",
    "pastDateError": "Нельзя запланировать Live-сессию в прошлом. Выберите будущую дату и время.",
    "fillAllFields": "Заполните все обязательные поля",
    "invalidDate": "Некорректная дата или время",
    "coverImage": "Обложка",
    "uploadCustomCover": "Загрузить свою картинку",
    "broadcastEvent": "ОПУБЛИКОВАТЬ LIVE-СЕССИЮ",
    "updateManifesto": "Редактировать манифест",
    "addManifestoVideo": "Добавить видео-манифест",
    "videoTitle": "Название видео",
    "videoTitlePlaceholder": "напр. Добро пожаловать в мою практику",
    "visibleOnProfile": "ВИДНО В ПРОФИЛЕ",
    "hiddenFromProfile": "СКРЫТО ИЗ ПРОФИЛЯ",
    "saveManifesto": "СОХРАНИТЬ МАНИФЕСТ",
    "newPost": "Новая публикация",
    "postLabel": "О чём вы думаете?",
    "postPlaceholder": "Поделитесь мыслями, идеями или новостями...",
    "pinnedToTop": "ЗАКРЕПЛЕНО",
    "pinThisPost": "ЗАКРЕПИТЬ",
    "publishPost": "ОПУБЛИКОВАТЬ"
  },
  "subscriptions": {
    "overline": "СООБЩЕСТВО",
    "title": "Связанный",
    "titleHighlight": "Коллектив",
    "signInHint": "Войдите, чтобы управлять подписками на мастеров.",
    "loading": "Загрузка подписок...",
    "noMasters": "Вы пока не подписаны ни на одного мастера.",
    "followingCount": "Вы связаны с {{count}} мастером",
    "followingCount_plural": "Вы связаны с {{count}} мастерами",
    "explore": "Исследовать мастеров",
    "exploreHint": "Найдите учителей, которые откликаются в вашем пути.",
    "browseMasters": "МАСТЕРА",
    "connectedSince": "ПОДПИСКА С {{year}}",
    "notificationsOn": "УВЕДОМЛЕНИЯ ВКЛ.",
    "enableAlerts": "ВКЛЮЧИТЬ УВЕДОМЛЕНИЯ"
  },
  "status": {
    "draft": "ЧЕРНОВИК",
    "reviewing": "НА РЕВЬЮ",
    "livePortfolio": "ОПУБЛИКОВАНО",
    "hidden": "СКРЫТО",
    "live": "ЭФИР"
  },
  "tabs": {
    "feed": "Лента",
    "practices": "Практики",
    "studio": "Студия",
    "circle": "Круг",
    "about": "О себе",
    "settings": "Настройки",
    "profile": "Профиль",
    "favorites": "Избранное",
    "events": "События",
    "rooms": "Мои Live-сессии",
    "media": "Медиа",
    "aboutMaster": "О мастере",
    "communityChat": "Чаты мастера",
    "masterChat": "Чаты мастера",
    "masterChats": "Чаты мастера",
    "lightPath": "Путь Света",
    "programs": "Программы",
    "journal": "Дневник"
  },
  "quickActions": {
    "label": "Быстрые действия",
    "liveBadge": "LIVE",
    "live": {
      "title": "Live-сессия",
      "subtitle": "Запланировать или начать прямо сейчас"
    },
    "offline": {
      "title": "Оффлайн событие",
      "subtitle": "Место, дата, количество мест"
    },
    "media": {
      "title": "Загрузить медиа",
      "subtitle": "Фото и видео практик"
    },
    "program": {
      "title": "Создать программу",
      "subtitle": "Цикл практик с расписанием"
    }
  },
  "feedSidebar": {
    "upcomingEvent": "Ближайшее событие",
    "allEvents": "Все события",
    "goTo": "Перейти",
    "allRecordings": "Все записи",
    "noRecordings": "Пока нет записей Live-сессий.",
    "roomRecording": "Запись Live-сессии",
    "aboutMaster": "О мастере",
    "more": "Подробнее",
    "participants": {
      "one": "{{count}} участник",
      "few": "{{count}} участника",
      "many": "{{count}} участников"
    },
    "yourNextBroadcast": "Ваша ближайшая Live-сессия",
    "broadcastStatus": {
      "live": "Идёт Live-сессия",
      "due": "Время начала наступило",
      "scheduled": "Запланирован"
    },
    "broadcastCta": {
      "openRoom": "Открыть Live-сессию",
      "returnToRoom": "Вернуться в Live-сессию",
      "prepare": "Подготовиться к Live-сессии",
      "start": "Начать Live-сессию",
      "returnToBroadcast": "Вернуться в Live-сессию"
    },
    "startsIn": "Через {{value}}",
    "unitHour": "ч",
    "unitMinute": "мин",
    "latestRecordings": "Последние записи"
  },
  "communityChat": {
    "previewEmpty": "Сообщений пока нет",
    "subscribeCta": "Подпишитесь, чтобы участвовать в обсуждении",
    "subscribeButton": "Подписаться"
  },
  "circleTab": {
    "search": "Поиск",
    "wallOf": "Стена {{name}}",
    "join": "ПРИСОЕДИНИТЬСЯ",
    "members": "{{count}} участников",
    "online": "{{count}} онлайн",
    "subTabs": {
      "chat": "Чат",
      "media": "Медиа",
      "links": "Ссылки",
      "events": "События",
      "pins": "Пины"
    },
    "filters": {
      "all": "Все",
      "streams": "Live-сессии",
      "online": "Онлайн",
      "recordings": "Записи"
    },
    "roomsTitle": "LIVE-СЕССИИ И ЗАПИСИ",
    "room": "LIVE-СЕССИЯ",
    "recording": "ЗАПИСЬ LIVE-СЕССИИ",
    "startsIn": "ЧЕРЕЗ {{time}}",
    "noRooms": "Live-сессий и записей пока нет",
    "emptyChat": "Здесь пока тихо. Начните обсуждение!",
    "joinToChat": "Вступите в круг, чтобы писать",
    "sharePrompt": "Поделиться с сообществом...",
    "noCircles": "Вы пока не вступили ни в один круг",
    "connecting": "Подключаюсь к чату…",
    "quietBeFirst": "Здесь пока тихо. Будьте первым.",
    "privateCircle": "Этот чат закрыт.",
    "loadFailed": "Не удалось загрузить чат.",
    "noMedia": "Здесь пока нет медиа",
    "joinShort": "Войти",
    "noMessages": "Сообщений пока нет",
    "joinToWrite": "Присоединитесь, чтобы писать"
  },
  "feedFilters": {
    "upcoming": "Скоро",
    "recordings": "Записи",
    "saved": "Сохранения",
    "newPractices": "Новые практики",
    "all": "Все",
    "typeAll": "Все виды",
    "typeLive": "Live-сессии",
    "typeRooms": "Практики",
    "typeOffline": "Офлайн"
  },
  "studio": {
    "createTitle": "Создать",
    "publicationsTitle": "Мои публикации",
    "chips": {
      "all": "Все",
      "planned": "Запланированные",
      "archive": "Архив",
      "myPractices": "Мои практики",
      "saved": "Сохранения"
    },
    "create": {
      "quickRoom": "Начать сейчас",
      "quickRoomHint": "Сразу войти",
      "livePractice": "Live-практика",
      "livePracticeHint": "Анонс + календарь",
      "liveSession": "Live-сессия",
      "liveSessionHint": "Стрим события",
      "offlineEvent": "Офлайн",
      "offlineEventHint": "Событие в месте",
      "uploadPractice": "Загрузить практику",
      "uploadPracticeHint": "В библиотеку"
    }
  },
  "hero": {
    "subscribe": "Подписаться",
    "subscribed": "Подписаны",
    "friends": "Друзья",
    "message": "Сообщение",
    "unfollow": "Отписаться",
    "mutualHint": "При взаимной подписке откроется чат",
    "intentionCta": "Добавьте намерение"
  },
  "editProfile": {
    "title": "Редактировать профиль",
    "coverLabel": "ОБЛОЖКА",
    "orPickImage": "ИЛИ ВЫБЕРИТЕ КАРТИНКУ",
    "noImage": "Без картинки",
    "coversFailed": "Подборка обложек не загрузилась.",
    "coverPickFailed": "Не получилось взять эту обложку. Попробуйте ещё раз, выберите другую или загрузите свою.",
    "coverPickTimeout": "Обложка не загрузилась: сервер не ответил. Проверьте связь и попробуйте ещё раз или выберите другую.",
    "coverRetry": "Повторить",
    "avatarLabel": "ФОТО ПРОФИЛЯ",
    "uploadPhoto": "Загрузить фото",
    "uploadCover": "Загрузить обложку",
    "replaceCover": "Заменить обложку",
    "removeCover": "Удалить обложку",
    "removeShort": "Удалить",
    "nameLabel": "ИМЯ",
    "namePlaceholder": "Ваше имя",
    "surnameLabel": "ФАМИЛИЯ",
    "surnamePlaceholder": "Ваша фамилия",
    "intentionLabel": "НАМЕРЕНИЕ",
    "intentionPlaceholder": "Например: «Хочу медитировать ежедневно 10 минут ближайшие 4 месяца»",
    "bioLabel": "О СЕБЕ",
    "bioPlaceholder": "Пара слов о себе. Откуда вы, чем живёте, что для вас важно.",
    "manifestoLabel": "ВИДЕО-МАНИФЕСТ",
    "uploadVideo": "Загрузить видео",
    "videoSizeHint": "MP4, до ~100 МБ",
    "coverThumbLabel": "Обложка",
    "useCurrentFrame": "Использовать текущий кадр",
    "replaceVideo": "Заменить видео",
    "pauseHint": "Поставьте видео на паузу в нужный момент и нажмите «Использовать текущий кадр».",
    "loadVideoFirst": "Сначала загрузите видео, затем выберите кадр для обложки.",
    "uploadingVideo": "Загружаем видео…",
    "socialsLabel": "КОНТАКТЫ И СОЦСЕТИ",
    "websiteRow": "Сайт",
    "cancel": "Отмена",
    "save": "Сохранить"
  },
  "native": {
    "sectionSoon": "Раздел «{{section}}» скоро",
    "notificationsUnread": "Уведомления, непрочитанных: {{count}}",
    "shareProfile": "Профиль {{name}} в Agapella",
    "youBadge": "ЭТО ВЫ",
    "becomeMaster": "СТАТЬ МАСТЕРОМ",
    "applicationPending": "ЗАЯВКА НА РАССМОТРЕНИИ",
    "followersWord_one": "подписчик",
    "followersWord_few": "подписчика",
    "followersWord_many": "подписчиков",
    "followersWord_other": "подписчиков",
    "followingWord_one": "подписка",
    "followingWord_few": "подписки",
    "followingWord_many": "подписок",
    "followingWord_other": "подписок",
    "profileTab": {
      "aboutMe": "Обо мне",
      "description": "Описание",
      "notFilled": "не заполнено",
      "location": "Город / страна",
      "notSpecified": "не указано",
      "timezone": "Часовой пояс",
      "bySystem": "по системе",
      "lookingFor": "Что я ищу",
      "notChosenHint": "Не выбрано — заполните в «Настройках»",
      "interests": "Мои интересы",
      "preferences": "Предпочтения",
      "eventFormat": "Формат событий",
      "daytime": "Время суток",
      "timeRange": "Интервал времени",
      "language": "Язык",
      "myPath": "Мой путь",
      "withUsSince": "С нами с",
      "roomsCreated": "Создано Live-сессий",
      "followers": "Подписчики",
      "following": "Подписки",
      "notChosen": "не выбрано"
    },
    "editProfile": {
      "nameMin": "Укажите имя (минимум 2 символа).",
      "saveFailed": "Не удалось сохранить. Попробуйте ещё раз.",
      "name": "Имя",
      "surname": "Фамилия",
      "bioPlaceholder": "Расскажите о себе и своём подходе",
      "experiencePlaceholder": "Сколько лет в практике, чем занимаетесь",
      "educationPlaceholder": "Дипломы, курсы, сертификаты",
      "uniquenessPlaceholder": "Чем ваш подход отличается"
    },
    "basicInfo": {
      "nickname": "Ник",
      "nicknamePlaceholder": "Например, anna_light",
      "title": "Основная информация",
      "bioPlaceholder": "Пара слов о себе",
      "locationPlaceholder": "Например: Москва",
      "timezonePlaceholder": "Например: Europe/Moscow"
    },
    "followersModal": {
      "loadFailed": "Не удалось загрузить список",
      "unavailable": "Список временно недоступен. Попробуйте позже.",
      "noFollowers": "Пока никто не подписался.",
      "noFollowing": "Пока ни на кого не подписан.",
      "subscribed": "Подписан",
      "title": "Связи",
      "close": "Закрыть",
      "groupAwaiting": "Ждут ответа",
      "groupMutual": "Взаимные",
      "groupOnlyYou": "Только вы читаете",
      "captionThey": "читает вас",
      "captionYou": "вы читаете",
      "captionMutual": "вы читаете друг друга",
      "masterTag": "мастер",
      "reply": "В ответ",
      "follow": "Читать",
      "followingNow": "Читаю",
      "message": "Написать: {{name}}",
      "legendThey": "он → вы",
      "legendYou": "вы → он",
      "legendMutual": "взаимно"
    },
    "userSettings": {
      "tabBasic": "Основное",
      "tabPhoto": "Фото/Обложка",
      "tabExtra": "Дополнительно",
      "savedBody": "Ваши предпочтения обновлены.",
      "saveFailed": "Не удалось сохранить изменения.",
      "editBasic": "Изменить основную информацию",
      "multiSelectHint": "Множественный выбор — выберите всё, что откликается.",
      "interestsHint": "Чем чаще встречаемся с интересом — тем точнее рекомендации.",
      "preferredDaytime": "Предпочтительное время суток",
      "timeRangeHint": "Доступны интервалы в пределах выбранного времени суток",
      "saveChanges": "СОХРАНИТЬ ИЗМЕНЕНИЯ",
      "accountHint": "Выход завершает сессию на этом устройстве. Удаление аккаунта — действие, которое отменяется только письмом в поддержку."
    },
    "chatTab": {
      "notPublished": "Чаты мастера станут доступны после публикации профиля.",
      "discussions": "Обсуждения",
      "noDiscussions": "Обсуждений пока нет.",
      "noChat": "У этого обсуждения пока нет чата.",
      "generalChat": "Общий чат сообщества",
      "eventDiscussion": "Обсуждение события"
    },
    "mediaTab": {
      "open": "Открыть",
      "removeFavorite": "Убрать из избранного",
      "edit": "Редактировать",
      "heroSub": "Управляйте своими практиками\nи делитесь с миром",
      "upload": "Загрузить новую практику",
      "mine": "Мои медиа",
      "emptyMine": "Пока нет загруженных практик",
      "emptyFavorites": "Пока нет избранного"
    },
    "circleChat": {
      "quiet": "Пока тихо — начните беседу.",
      "noComments": "Комментариев пока нет.",
      "placeholder": "Сообщение…"
    },
    "liveSessionsTab": {
      "recordings": "Записи Live-сессий",
      "management": "Управление",
      "rooms": "Совместные практики"
    },
    "rooms": {
      "scheduled": "Запланирована",
      "finished": "Завершена",
      "minutesCount_one": "{{count}} минута",
      "minutesCount_few": "{{count}} минуты",
      "minutesCount_many": "{{count}} минут",
      "minutesCount_other": "{{count}} минут",
      "hoursCount_one": "{{count}} час",
      "hoursCount_few": "{{count}} часа",
      "hoursCount_many": "{{count}} часов",
      "hoursCount_other": "{{count}} часов",
      "sessionsWord_one": "сессия",
      "sessionsWord_few": "сессии",
      "sessionsWord_many": "сессий",
      "sessionsWord_other": "сессий",
      "hidden": "Скрыто",
      "deleteTitle": "Удалить Live-сессию?",
      "deleteBody": "«{{title}}» будет удалена. Действие нельзя отменить.",
      "deleteFailed": "Не удалось удалить",
      "tryAgain": "Попробуйте ещё раз.",
      "upTo": "до {{count}}",
      "start": "Начать",
      "empty": "Live-сессий пока нет. Создайте первую.",
      "more": "Ещё {{count}}",
      "calendar": "Календарь Live-сессий",
      "reset": "Сбросить",
      "noRoomsThisDay": "На этот день Live-сессий нет.",
      "activity": "Ваша активность",
      "totalRooms": "Всего Live-сессий",
      "totalTime": "Общее время",
      "thisWeek": "Эта неделя",
      "editTitle": "Редактировать Live-сессию",
      "titleLabel": "Название",
      "titlePlaceholder": "Название Live-сессии",
      "descPlaceholder": "О чём Live-сессия",
      "visibility": "Кто видит"
    },
    "feed": {
      "noPosts": "Пока нет публикаций",
      "publish": "Опубликовать",
      "photo": "Фото",
      "video": "Видео",
      "signInToReport": "Чтобы отправить жалобу, войдите в аккаунт.",
      "comments": "Комментарии",
      "noComments": "Пока нет комментариев. Будьте первым.",
      "commentPlaceholder": "Написать комментарий…",
      "more": "Ещё",
      "shareTitle": "{{name}} в Agapella",
      "share": "Поделиться",
      "linkCopied": "Ссылка скопирована",
      "copyLink": "Скопировать ссылку",
      "notSent": "Не отправлено",
      "galleryTitle": "Доступ к галерее",
      "galleryBody": "Разрешите доступ к медиа, чтобы прикрепить файл.",
      "photosOrVideo": "К посту можно прикрепить либо фотографии, либо видео.",
      "badImage": "Не получилось прочитать этот файл. Подойдут JPEG, PNG или WebP.",
      "cancelSendingFeed": "Отменить",
      "photoSendingCount": "Отправляем фото — {{done}} из {{total}}",
      "savingPhoto": "Сохраняем фото — {{percent}}%",
      "tooManyPhotosTitle": "Слишком много фото",
      "tooManyPhotosBody": "К посту можно прикрепить не более {{count}} фотографий.",
      "badVideo": "Не получилось прочитать этот файл. Выберите другое видео.",
      "editPost": "Редактировать пост",
      "postTextPlaceholder": "Текст публикации",
      "replacePhoto": "Заменить фото",
      "addPhoto": "Добавить фото",
      "restorePrevious": "Вернуть прежние",
      "uploadingPercent": "Загрузка… {{percent}}%",
      "videoWillBeRemoved": "Видео будет удалено",
      "undo": "Отменить",
      "addVideo": "Добавить видео",
      "uploading": "Загрузка",
      "attachPhoto": "Прикрепить фото",
      "attachVideo": "Прикрепить видео",
      "edit": "Редактировать",
      "delete": "Удалить"
    },
    "post": {
      "failTitle": "Не удалось",
      "editorOpenFailed": "Не получилось открыть редактор. Попробуйте позже.",
      "eventOpenFailed": "Не получилось открыть событие. Попробуйте позже.",
      "tryLater": "Попробуйте ещё раз чуть позже.",
      "linkedPractices": "практик",
      "linkedEvents": "событий",
      "pinned": "· Закреплено",
      "menuA11y": "Меню публикации",
      "onlineSessionAnnouncement": "Анонс Онлайн сессии",
      "eventAnnouncement": "Анонс события",
      "sessionEnded": "Live-сессия завершилась",
      "sessionAnnouncement": "Анонс Live-сессии",
      "goToSession": "Перейти к сессии",
      "unpin": "Открепить",
      "pin": "Закрепить",
      "deleteTitle": "Удалить публикацию?",
      "deleteEverywhereHint": "«Везде» уберёт и саму запись из {{place}} — не только из ленты. Действие нельзя отменить.",
      "deleteFeedOnly": "Только из ленты",
      "deleteEverywhere": "Удалить везде (и из {{place}})",
      "deleteMessage": "Это действие нельзя отменить."
    },
    "userFeed": {
      "empty": "Здесь появятся ваши публикации и то, чем делятся мастера, на которых вы подписаны.",
      "showMore": "Показать ещё",
      "deleteBody": "Её больше не будет в вашей ленте и в вашем профиле.",
      "profileA11y": "Профиль: {{name}}",
      "openPost": "Открыть публикацию",
      "captionRequired": "Добавьте пару слов — публикация без текста не сохранится.",
      "photoSending": "Отправляем фото — {{percent}}%",
      "photoChecking": "Проверяем публикацию",
      "cancelSending": "Отменить",
      "photoOrVideo": "К публикации можно приложить либо фото, либо видео.",
      "galleryPhoto": "Разрешите доступ к медиа, чтобы прикрепить фото.",
      "galleryVideo": "Разрешите доступ к медиа, чтобы прикрепить видео.",
      "sourceMaster": "Мастер",
      "sourceOfficial": "Agapella",
      "sourceCommunity": "Сообщество",
      "audienceLabel": "Аудитория",
      "audiencePublic": "Для всех",
      "postLockedTitle": "Эта публикация доступна подписчикам мастера",
      "postLockedBody": "Подпишитесь на {{name}}, чтобы её прочитать",
      "postLockedMaster": "мастера",
      "postLockedCta": "Подписаться на мастера",
      "postLockedSignIn": "Войдите, чтобы подписаться на мастера и прочитать публикацию.",
      "postGone": "Публикация недоступна: её удалили или скрыли.",
      "postLoadFailed": "Не получилось открыть публикацию.",
      "audienceSubscribers": "Для подписчиков",
      "photoLimit": "Больше {{count}} фотографий в одну публикацию не поместится.",
      "reactionA11y": "Реакция {{emoji}}, поставили {{count}}",
      "commentsCount": "Комментарии: {{count}}",
      "commentsEmptyAction": "Прокомментировать",
      "commentsEmpty": "Пока никто не написал. Будьте первым.",
      "commentPlaceholder": "Написать комментарий",
      "commentSend": "Отправить комментарий"
    },
    "guest": {
      "blockConfirm": "Заблокировать {{name}}? Вы больше не будете получать сообщения от этого пользователя.",
      "youBlockedName": "Вы заблокировали {{name}}",
      "blockedBody": "Публикации и сообщения этого пользователя больше не показываются вам, а он не может вам писать. Мы передали жалобу модерации и разберём её в течение 24 часов.",
      "aboutUser": "О пользователе",
      "masterNoBio": "Мастер пока не добавил описание.",
      "userNoBio": "Пользователь пока не добавил описание.",
      "signInToFollow": "Войдите, чтобы подписаться",
      "signInForNotifications": "Войдите, чтобы включить уведомления",
      "directionA11y": "Практики по направлению {{direction}}",
      "directionHint": "Откроет библиотеку практик по этому направлению",
      "follow": "Подписаться",
      "following": "Вы подписаны",
      "unfollow": "Отписаться",
      "write": "Написать",
      "writeMessage": "Написать сообщение",
      "shareProfileA11y": "Поделиться профилем",
      "masterNotifications": "Уведомления о мастере",
      "profileNotFound": "Профиль не найден",
      "profileLoadFailed": "Не удалось открыть профиль",
      "profileNotFoundHint": "Возможно, страница удалена или ссылка устарела.",
      "profileLoadFailedHint": "Проверьте связь и попробуйте ещё раз.",
      "user": "Пользователь",
      "profileHidden": "Профиль скрыт",
      "profileHiddenBody": "Этот пользователь ограничил доступ к своему профилю.",
      "browseMasters": "Смотреть мастеров",
      "feedLoadFailed": "Не удалось загрузить публикации.",
      "masterPractices": "Практики {{name}}",
      "chatsLoadFailed": "Не удалось загрузить чаты.",
      "chatsSubscribeHint": "После подписки откроются обсуждения мастера и поле для сообщений."
    },
    "lightPath": {
      "flame": "Пламя Любви",
      "soulLight": "Свет Души",
      "level": "Уровень",
      "cardTitle": "Путь Света {{name}}",
      "cardLoadingA11y": "{{title}}. Загружается.",
      "cardA11y": "{{title}}. Пламя Любви: {{streak}}. Свет Души: {{xp}}. Уровень: {{level}}.",
      "streakDays_one": "{{count}} день подряд",
      "streakDays_few": "{{count}} дня подряд",
      "streakDays_many": "{{count}} дней подряд",
      "streakDays_other": "{{count}} дней подряд"
    }
  },
  "journal": {
    "title": "Мои записи",
    "subtitle": "Рефлексии после практик. Их видишь только ты.",
    "loadFailedTitle": "Не удалось загрузить",
    "loadFailedText": "Записи на месте — не дошёл запрос. Попробуй ещё раз.",
    "retry": "Повторить",
    "emptyTitle": "Здесь будут твои записи",
    "emptyText": "После практики Агапелла предложит ненадолго остановиться и записать, что было. Записи появятся здесь — их можно перечитать, поправить или удалить.",
    "afterPractice": "После практики",
    "afterPracticeNamed": "После практики «{{title}}»",
    "afterLiveNamed": "После Live-сессии «{{title}}»",
    "privateToMe": "Только для меня",
    "aiMayRead": "Агапелла может читать",
    "visibilityLabel": "Кто может читать",
    "visibilityHint": "Закрытую запись Агапелла не видит совсем.",
    "visibilityFailed": "Не получилось поменять. Запись осталась как была.",
    "freeForm": "Свободная заметка",
    "otherAnswer": "Ответ",
    "edit": "Изменить",
    "delete": "Удалить",
    "save": "Сохранить",
    "cancel": "Отмена",
    "close": "Закрыть",
    "saveFailed": "Не получилось сохранить. Текст остался здесь — попробуй ещё раз.",
    "emptyEdit": "В записи не осталось ни слова. Если она больше не нужна, её можно удалить.",
    "deleteTitle": "Удалить запись?",
    "deleteText": "Вернуть её будет нельзя.",
    "deleteConfirm": "Удалить",
    "deleteFailed": "Не получилось удалить. Попробуй ещё раз.",
    "openA11y": "Открыть запись от {{date}}",
    "reflection": {
      "title": "Рефлексия",
      "hint": "Отвечать на все вопросы не нужно — только на те, на которые хочется.",
      "save": "Сохранить",
      "saveFailed": "Не получилось сохранить. Текст остался здесь — попробуй ещё раз.",
      "close": "Закрыть",
      "savedTitle": "Запись сохранена",
      "savedText": "Перечитать её, поправить или закрыть от Агапеллы можно в дневнике — он в твоём профиле.",
      "openJournal": "Мои записи",
      "done": "Готово",
      "offerButton": "Записать пару строк"
    },
    "privacy": {
      "title": "Рефлексия",
      "intro": "После практики можно ненадолго остановиться и записать, что было. Несколько наводящих вопросов — или свободная форма, если отвечать на них не хочется.",
      "readers": "Записи видишь только ты. Отдельно решается, может ли их читать Агапелла: если да — она будет опираться на них, подбирая практики и продолжая разговор. {{privacyHint}}",
      "note": "Выбор сохранится, и спрашивать при каждой записи мы не будем. Поменять его можно в настройках, а закрыть отдельную запись от Агапеллы — прямо в ней.",
      "aiMayRead": "Агапелла может читать",
      "privateToMe": "Только для меня"
    }
  }
}
